import React from "react";

function PassesNConcession() {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">Passes & Concession</h3>
        <h5 className="letters-color-section-sub-heading"></h5>

        <div className="letters-color-section-table-section">
          <div className="heading-main">
            I. Monthly Passes
            <div className="heading">
              <div className="heading">
                KSRTC is issuing monthly passes at concessional rates to
                passengers travelling between two places on a daily basis like
                employees, students, traders etc. These passes are issued at all
                bus stations. The Monthly passes are valid for travel along with
                Identity card issued by KSRTC.
              </div>
              <div className="heading">
                Photo-Identity cards valid for one year are issued by KSRTC by
                collecting Rs.50/- per card.
              </div>
              <div className="heading">
                Monthly passes issued for Express services are valid for travel
                in both Express and Ordinary services.
              </div>
              <div className="heading">
                Monthly passes issued for Ordinary services are valid for travel
                in Ordinary services only.
              </div>
            </div>
            <div className="heading-black">
              a. Monthly pass rates for Mofussil services w.e.f. 01-03-2020.
            </div>
            <div className="heading">
              <table>
                <tr>
                  <th>Chargeable stage</th>
                  <th>Express Pass Rate (In Rs.)</th>
                  <th>Ordinary Pass Rate (In Rs.)</th>
                </tr>
                <tr>
                  <td>1</td>
                  <td>450/-</td>
                  <td>400/-</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>700/-</td>
                  <td>650/-</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>1100/-</td>
                  <td>900/-</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>1250/-</td>
                  <td>1100/-</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>1350/-</td>
                  <td>1200/-</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>1550/-</td>
                  <td>1300/-</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>1700/-</td>
                  <td>1400/-</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>1850/-</td>
                  <td>1550/-</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>2000/-</td>
                  <td>1700/-</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>2150/-</td>
                  <td>1800/-</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>2250/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>2300/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>2350/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>2450/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>15</td>
                  <td>2550/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td>2600/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>17</td>
                  <td>2650/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>18</td>
                  <td>2700/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>19</td>
                  <td>2750/-</td>
                  <td>N.A.</td>
                </tr>
                <tr>
                  <td>20</td>
                  <td>2800/-</td>
                  <td>N.A.</td>
                </tr>
              </table>
            </div>
            <div className="heading-black">
              b. Monthly pass rates for City services w.e.f. 01-03- 2020
            </div>
            <div className="heading">
              KSRTC is issuing monthly passes at concessional rates for travel
              in City services also. The Monthly passes are valid for travel
              along with Identity card issued by KSRTC.
              <div className="heading">
                <table>
                  <tr>
                    <th>City</th>
                    <th>Pass Type</th>
                    <th>For General Public (Rs.)</th>
                    <th>For Senior Citizens (Rs.)</th>
                  </tr>
                  <tr>
                    <td>Mysore City</td>
                    <td>City services</td>
                    <td>700/-</td>
                    <td>630/-</td>
                  </tr>
                  <tr>
                    <td>Mysore City</td>
                    <td>City and Suburban services</td>
                    <td>925/-</td>
                    <td>830/-</td>
                  </tr>
                  <tr>
                    <td>Mysore City</td>
                    <td>Volvo services</td>
                    <td>1150/-</td>
                    <td>N.A.</td>
                  </tr>
                  <tr>
                    <td>Mangalore City</td>
                    <td>City services</td>
                    <td>650/-</td>
                    <td>585/-</td>
                  </tr>
                  <tr>
                    <td>Mangalore City</td>
                    <td>BC Road / Bantwal / Pane</td>
                    <td>900/-</td>
                    <td>810/-</td>
                  </tr>
                  <tr>
                    <td>Tumkur City</td>
                    <td>Upto 10 chargeable stages</td>
                    <td>550/-</td>
                    <td>495/-</td>
                  </tr>
                  <tr>
                    <td>Hassan City</td>
                    <td>Upto 8 chargeable stages</td>
                    <td>600/-</td>
                    <td>540/-</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="heading-main">
            II. Daily Passes
            <div className="heading-black">
              a. Daily Passes in Mysore City Limits
            </div>
            <div className="heading">
              Daily passes valid for the day are issued for the benefit of
              passengers to travel in Mysore, Mangalore City limits. 
              <div className="heading">
                <table>
                  <tr>
                    <th>Type of service Rates</th>
                    <th>Rates</th>
                  </tr>
                  <tr>
                    <td>Mysore City & Suburban services</td>
                    <td>60/-</td>
                  </tr>
                  <tr>
                    <td>Mysore City Volvo services</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>Mangaluru-Manipal</td>
                    <td>170/-</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="heading-black">
              b. Daily Passes to Bangalore City from nearby places (Allowed for
              travel in both KSRTC and BMTC services) w.e.f. 01-03- 2020
            </div>
            <div className="heading">
              Daily passes valid for one day (upto midnight) are issued for the
              benefit of passengers to travel to Bangalore from nearby Taluka /
              Towns. These passes are allowed in Mofussil Ordinary / Express
              services of KSRTC and City / Suburban services of BMTC.
              <div className="heading">
                <table>
                  <tr>
                    <th>S.No</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Pass Rate (Rs.)</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Kanakapura</td>
                    <td>Bengaluru</td>
                    <td>150/-</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Harohalli</td>
                    <td>Bengaluru</td>
                    <td>115/-</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Channapatna</td>
                    <td>Bengaluru</td>
                    <td>150/-</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Ramangara</td>
                    <td>Bengaluru</td>
                    <td>120/-</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Magadi</td>
                    <td>Bengaluru</td>
                    <td>105/-</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Chikkaballapura</td>
                    <td>Bengaluru</td>
                    <td>150/-</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Gowribidanuru</td>
                    <td>Bengaluru</td>
                    <td>185/-</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Sidlagatta</td>
                    <td>Bengaluru</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Chintamani</td>
                    <td>Bengaluru</td>
                    <td>185/-</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Kolar</td>
                    <td>Bengaluru</td>
                    <td>175/-</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Tumkur</td>
                    <td>Bengaluru</td>
                    <td>160/-</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>Kunigal</td>
                    <td>Bengaluru</td>
                    <td>160/-</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>Dabaspete</td>
                    <td>Bengaluru</td>
                    <td>120/-</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>Madduru</td>
                    <td>Bengaluru</td>
                    <td>165/-</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="heading-black">
              c. Daily Passes to Mysore City from nearby places (Allowed for
              travel in Mysore City services) w.e.f. 01-03- 2020
            </div>
            <div className="heading">
              Daily passes valid for the day (upto midnight) are issued for the
              benefit of passengers to travel to Mysore from nearby Taluka /
              Towns. These passes are allowed in Mofussil Ordinary / Express
              services of KSRTC and City / Suburban services in Mysore City.
              <div className="heading">
                <table>
                  <tr>
                    <th>S.No</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Pass Rate (Rs.)</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Periyapattana</td>
                    <td>Mysuru</td>
                    <td>150/-</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Hunasuru</td>
                    <td>Mysuru</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>K.R Nagara</td>
                    <td>Mysuru</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Saraguru</td>
                    <td>Mysuru</td>
                    <td>110/-</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>H.D Kote</td>
                    <td>Mysuru</td>
                    <td>110/-</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Malavalli</td>
                    <td>Mysuru</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Bannuru</td>
                    <td>Mysuru</td>
                    <td>70/-</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Mandya</td>
                    <td>Mysuru</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>K.R Pete</td>
                    <td>Mysuru</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Gundlupete</td>
                    <td>Mysuru</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Chamrajnagar</td>
                    <td>Mysuru</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>Kollegala</td>
                    <td>Mysuru</td>
                    <td>125/-</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>Nanjanagudu</td>
                    <td>Mysuru</td>
                    <td>70/-</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>Pandavapura</td>
                    <td>Mysuru</td>
                    <td>80/-</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>H.D. Kote Handpost</td>
                    <td>Mysuru</td>
                    <td>100/-</td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>T. Narasipura</td>
                    <td>Mysuru</td>
                    <td>60/-</td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>Yalandur</td>
                    <td>Mysuru</td>
                    <td>120/-</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="heading-black">
              d. Daily Passes on other routes w.e.f. 01-03- 2020
            </div>
            <div className="heading">
              Daily passes valid for the day are issued for the benefit of
              passengers to travel on routes listed below. These passes are
              allowed in Mofussil Ordinary / Express services of KSRTC.
              <div className="heading">
                <table>
                  <tr>
                    <th>S.No</th>
                    <th>Routes</th>
                    <th>Pass Rate (Rs.)</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Davangere-Chitradurga</td>
                    <td>120/-</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Davangere-Shimoga</td>
                    <td>180/-</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Davangere-Ranibennur</td>
                    <td>90/-</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Harihara-Shimoga</td>
                    <td>160/-</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Chitradurga-Hiriyuru</td>
                    <td>90/-</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="heading-main">
            IV. Concession to Senior Citizens
            <div className="heading">
              Senior Citizens who are aged 60 years or above are extended with
              25% ticket fare concession.
            </div>
            <div className="heading">
              This facility is extended in City, Suburban, Ordinary, Express,
              Semi Luxury and Rajahamsa buses of KSRTC including interstate
              operations also.
            </div>
            <div className="heading">
              To avail this concession facility, Senior Citizens need to produce
              the age proof documents. They can also show the IDs loaded through
              Digilocker app viz Aadhar card, Driving License. the ID should
              contain place of residence at Karnataka only.
              <div className="heading">
                <table>
                  <tr>
                    <th>Identity Card Type</th>
                    <th>Original / Soft Copy</th>
                  </tr>
                  <tr>
                    <td style={{width: "50%"}}>
                      Driving License, Voter ID card, Passport, Aadhar card,
                      Ration card, Senior citizen ID Card
                    </td>
                    <td>
                      1. Original copy of ID card with photo of Senior Citizen.
                      <br />
                      2. Soft copy of the ID card produced through Digilocker
                      app
                    </td>
                  </tr>
                  <tr>
                    <td>Photo ID card issued by any Government Department.</td>
                    <td>Original ID</td>
                  </tr>
                  <tr>
                    <td>ID Card issued by KSRTC</td>
                    <td>Original ID</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="heading-main">
            V. Passes to Physically Challenged Persons:
            <div className="heading">
              KSRTC is issuing concessional passes to Physically challenged
              persons, residents of Karnataka State. Details are as below:
              <div className="heading">
                <ul>
                  <li>
                    The pass rate for Physically Challenged Persons is Rs.660/-
                    per annum as decided by the Government of Karnataka.
                  </li>
                  <li>
                    These passes will be issued to persons with disability of
                    40% and above covering visual, hearing, Amblyopia, Mental
                    disorder, Dementia, Loco Moto Disability, Leprosy infected
                    patients.
                  </li>
                  <li>
                    These pass holders are allowed to travel in City, Suburban,
                    Ordinary and Express routes of KSRTC, BMTC, NEKRTC and
                    NWKRTC buses with in the limit of 100 kms from the place of
                    residence.
                  </li>
                  <li>
                    Other details are given in GSO No. 779/2016 dated
                    20-12-2016.
                  </li>
                </ul>
              </div>
            </div>
            <div className="heading-black">
              Travel facility and Validity of the pass:
              <div className="heading">
                These pass holders are allowed to travel in City, Suburban,
                Ordinary and Express routes of KSRTC, BMTC, NEKRTC and NWKRTC
                buses within the limit of 100 kms from the pass the place of
                residence of the pass holder.
              </div>
              <div className="heading">
                Pass will be issued with validity from January to December every
                year.
              </div>
              <div className="heading">Passes are allowed within State only.</div>
            </div>
            <div className="heading-black">
              Pass issue procedure
              <div className="heading">
                To avail new pass and also renewal of the pass, beneficiary
                should be personally present and submit the original Disability
                card for verification. The person who is having disability
                explained above should fill the application form available at
                the concerned Divisional Offices.
              </div>
              <div className="heading">
                Application should be attached with necessary documents like
                Disability certificate cum ID card issued by District welfare
                office of Disabled persons & Senior citizens with certified by
                minimum 02 Medical Officers viz Chairman / members of District
                Medical Board where beneficiary is living / UDID card.
              </div>
              <div className="heading">
                Passes will be renewed every year from 1st January to 28th
                February.
              </div>
              <div className="heading">
                New pass will be issued to the beneficiaries throughout the year
                subject to meeting the eligibility criteria.
              </div>
            </div>
            <div className="heading-black">
              Other conditions:
              <div className="heading">
                Government employees and other employees entitled to travel
                allowance are not eligible to obtain this pass.
              </div>
              <div className="heading">
                Pass holder should compulsorily carry the pass while traveling
                in the bus and shall produce the same to conductors / drivers /
                checking staff on demand.
              </div>
            </div>
          </div>

          <div className="heading-main">
            VI. Passes to Blind:
            <div className="heading">
              KSRTC is issuing free travel passes to fully Blind persons,
              residents of Karnataka State. Details are as below:
              <div className="heading">
                <ul>
                  <li>Blind passes are issued free of cost.</li>
                  <li>These passes are issued to 100% blind persons only.</li>
                  <li>
                    These pass holders are allowed to travel in City, Suburban,
                    Ordinary and Express buses of KSRTC, BMTC, NWKRTC and
                    NEKRTC.
                  </li>
                  <li>
                    These pass holders are allowed to travel anywhere within the
                    state and interstate buses also.
                  </li>
                  <li>
                    Other details are given in GSO No. 777/2016 dated
                    30-11-2016.
                  </li>
                </ul>
              </div>
            </div>
            <div className="heading-black">
              Pass issue procedure:
              <div className="heading">
                The person who is having full blind should fill the application
                form available at concerned Divisional Offices.
              </div>
              <div className="heading">
                Application should be attached with necessary documents like
                Full Blind certificate cum ID card with seal and sign issued by
                District welfare office of Disabled persons & Senior citizens
                with certified by minimum 02 Medical Officers of Primary level /
                Taluk level / District level / Bangalore Medical Board or UDID
                card.
              </div>
            </div>
            <div className="heading-black">
              Travel facility & validity of pass:
              <div className="heading">
                These pass holders are allowed to travel in City, Suburban,
                Ordinary and Express buses of KSRTC, BMTC, NWKRTC and NEKRTC.
              </div>
              <div className="heading">
                These pass holders are allowed to travel anywhere within the
                state and interstate buses also.
              </div>
              <div className="heading">
                These passes are valid for 05 years from the date of issue.
              </div>
              <div className="heading">
                These pass holders can reserve seats free of cost in services
                having advance reservation facility.
              </div>
            </div>
            <div className="heading-black">
              Other Conditions:
              <div className="heading">
                Pass holder should compulsorily carry the pass while traveling
                in the bus and shall produce the same to conductors / drivers /
                checking staff on demand.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PassesNConcession;
